import { getComposeEvent } from 'owa-calendar-compose-store-manager';

export function getAttendeeLists() {
    const event = getComposeEvent(null /* formId */);
    return event ? [event.RequiredAttendees, event.OptionalAttendees] : [];
}

export function getAllAttendees() {
    let attendeeLists = getAttendeeLists();
    return [...attendeeLists[0], ...attendeeLists[1]];
}
